<template>
  <div id="menu-units" role="tabpanel" class="tab-pane show" aria-labelledby="units-tab">
    <div class="submenu-nav-header">
      <div class="my-1 d-lg-none"></div>
      <h4 class="mb-0">Unit Management</h4>
      <small class="mb-1"><i>Administration and management of GPS and other tracking units/devices</i></small>
    </div>
    <ul class="nav nav-pills" id="submenu-units" role="tablist">
      <li v-if="security.canView('units') || security.can('units', 'units_basic_edit')" class="nav-item">
        <a id="sm-units-tab" class="nav-link submenu-nav-pill"
           :class="{active: isMenuTabActive('units')}" data-toggle="tab"
           href="#sm-units"
           role="tab" aria-controls="sm-units"
           aria-selected="true">
          <fa-icon icon="hdd"/>&nbsp;&nbsp;Units</a>
      </li>
      <li v-if="security.canView('sim_cards')" class="nav-item">
        <a id="sm-sim-cards-tab" class="nav-link submenu-nav-pill"
           :class="{active: isMenuTabActive('sim_cards')}" data-toggle="tab"
           href="#sm-sim-cards"
           role="tab" aria-controls="sm-sim-cards"
           aria-selected="false">
          <fa-icon icon="sim-card"/>&nbsp;&nbsp;Sim Cards</a>
      </li>
      <li v-if="security.canView('event_profiles_monitored') || security.canView('event_profiles_client')" class="nav-item">
        <a id="sm-event-profiles-tab" class="nav-link submenu-nav-pill"
           :class="{active: isMenuTabActive('event_profiles')}" data-toggle="tab"
           href="#sm-event-profiles"
           role="tab" aria-controls="sm-event-profiles"
           aria-selected="false">
          <fa-icon icon="sensor-on"/>&nbsp;&nbsp;Event Profiles</a>
      </li>
      <li v-if="security.canView('event_pools')" class="nav-item">
        <a id="sm-event-pools-tab" class="nav-link submenu-nav-pill"
           :class="{active: isMenuTabActive('event_pools')}" data-toggle="tab"
           href="#sm-event-pools"
           role="tab" aria-controls="sm-event-pools"
           aria-selected="false">
          <fa-icon icon="portal-enter"/>&nbsp;&nbsp;Event Pools</a>
      </li>
      <li v-if="security.can('units', 'units_technical')" class="nav-item">
        <a id="sm-technical-tab" class="nav-link submenu-nav-pill"
           :class="{active: isMenuTabActive('units_technical')}" data-toggle="tab"
           href="#sm-technical"
           role="tab" aria-controls="sm-technical"
           aria-selected="false">
          <fa-icon icon="microchip"/>&nbsp;&nbsp;Technical</a>
      </li>
    </ul>
    <div class="tab-content">
      <hr class="mt-2">
      <div id="sm-units" role="tabpanel" class="tab-pane" :class="{active: isMenuTabActive('units')}">
        <div class="row">
          <div v-if="security.canCreate('units')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.unitCreate.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.unitCreate.icon" :class="menu.unitCreate.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.unitCreate.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.unitCreate.details }}</p>
              </div>
            </router-link>
          </div>
          <div class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.unitFind.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.unitFind.icon" :class="menu.unitFind.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.unitFind.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.unitFind.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
        <div class="row">
          <!--
          <div v-if="security.canCreate('units')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.unitMultipleCreate.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.unitMultipleCreate.icon" :class="menu.unitMultipleCreate.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.unitMultipleCreate.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.unitMultipleCreate.details }}</p>
              </div>
            </router-link>
          </div>
          -->
          <div v-if="security.canCreate('units')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.unitFindArchive.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.unitFindArchive.icon" :class="menu.unitFindArchive.iconClass +' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.unitFindArchive.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.unitFindArchive.details }}</p>
              </div>
            </router-link>
          </div>
          <div v-if="security.can('units', 'unit_swapping')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.unitSwapping.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.unitSwapping.icon" :class="menu.unitSwapping.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.unitSwapping.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.unitSwapping.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
        <div v-if="security.isAboveClient()" class="row">
<!--          <h5 class="col-12 mt-3 mb-0"><fa-icon icon="exchange-alt" />&nbsp;Transfer Unit(s)</h5>-->
<!--          <div class="col-12"><hr class="mb-3 mt-2"></div>-->
          <div class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.UnitTransfer.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.UnitTransfer.icon" :class="menu.UnitTransfer.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.UnitTransfer.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.UnitTransfer.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
        <!-- Unit Groups Section -->
        <div class="row">
          <h5 class="col-12 mt-3 mb-0"><fa-icon icon="cubes" />&nbsp;Unit Groups</h5>
          <div class="col-12"><hr class="mb-3 mt-2"></div>
          <div v-if="security.canCreate('unit_groups')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.unitGroupCreate.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.unitGroupCreate.icon" :class="menu.unitGroupCreate.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.unitGroupCreate.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.unitGroupCreate.details }}</p>
              </div>
            </router-link>
          </div>
          <div class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.unitGroupFind.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.unitGroupFind.icon" :class="menu.unitGroupFind.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.unitGroupFind.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.unitGroupFind.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
        <!--
        <div class="row">
          <div class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.unitGroupMove.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.unitGroupMove.icon" :class="menu.unitGroupMove.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.unitGroupMove.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.unitGroupMove.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
        -->
      </div>
      <div id="sm-sim-cards" role="tabpanel" class="tab-pane" :class="{active: isMenuTabActive('sim_cards')}">
        <div class="row">
          <div v-if="security.canCreate('sim_cards')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.simCardsCreate.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.simCardsCreate.icon" :class="menu.simCardsCreate.iconClass +' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.simCardsCreate.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.simCardsCreate.details }}</p>
              </div>
            </router-link>
          </div>
          <div v-if="security.canView('sim_cards')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.simCardsFind.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.simCardsFind.icon" :class="menu.simCardsFind.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.simCardsFind.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.simCardsFind.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
        <div class="row">
          <h5 class="col-12 mt-3 mb-0"><fa-icon icon="cubes" />&nbsp;GDSPO Sim Cards</h5>
          <div class="col-12"><hr class="mb-3 mt-2"></div>
          <div v-if="security.canView('gdspo')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.gdspoSimCardsFind.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.gdspoSimCardsFind.icon" :class="menu.gdspoSimCardsFind.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.gdspoSimCardsFind.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.gdspoSimCardsFind.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div id="sm-event-profiles" role="tabpanel" class="tab-pane" :class="{active: isMenuTabActive('event_profiles')}">
        <div v-if="security.isAboveClient() || security.belongsToMultipleClients()" class="row">
          <div v-if="security.canCreate('event_profiles_monitored')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.monitoredEventProfilesCreate.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.monitoredEventProfilesCreate.icon" :class="menu.monitoredEventProfilesCreate.iconClass +' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.monitoredEventProfilesCreate.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.monitoredEventProfilesCreate.details }}</p>
              </div>
            </router-link>
          </div>
          <div v-if="security.canView('event_profiles_monitored')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.monitoredEventProfilesFind.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.monitoredEventProfilesFind.icon" :class="menu.monitoredEventProfilesFind.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.monitoredEventProfilesFind.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.monitoredEventProfilesFind.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
        <div class="row">
          <h5 class="col-12 mt-3 mb-0"><fa-icon icon="handshake" />&nbsp;Client Event Profiles</h5>
          <div class="col-12"><hr class="mb-3 mt-2"></div>
          <div v-if="security.canCreate('event_profiles_client')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.eventProfilesCreate.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.eventProfilesCreate.icon" :class="menu.eventProfilesCreate.iconClass +' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.eventProfilesCreate.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.eventProfilesCreate.details }}</p>
              </div>
            </router-link>
          </div>
          <div v-if="security.canView('event_profiles_client')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.eventProfilesFind.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.eventProfilesFind.icon" :class="menu.eventProfilesFind.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.eventProfilesFind.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.eventProfilesFind.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
        <div class="row">
          <div v-if="security.canCreate('event_profiles_client')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.eventProfilesClone.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.eventProfilesClone.icon" :class="menu.eventProfilesClone.iconClass +' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.eventProfilesClone.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.eventProfilesClone.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div id="sm-event-pools" role="tabpanel" class="tab-pane" :class="{active: isMenuTabActive('event_pools')}">
        <div class="row">
          <div v-if="security.canCreate('event_pools')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.eventPoolsCreate.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.eventPoolsCreate.icon" :class="menu.eventPoolsCreate.iconClass +' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.eventPoolsCreate.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.eventPoolsCreate.details }}</p>
              </div>
            </router-link>
          </div>
          <div v-if="security.canView('event_pools')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.eventPoolsFind.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.eventPoolsFind.icon" :class="menu.eventPoolsFind.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.eventPoolsFind.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.eventPoolsFind.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div id="sm-technical" role="tabpanel" class="tab-pane" :class="{active: isMenuTabActive('units_technical')}">
        <!-- <div class="row">
          <div v-if="security.can('units', 'units_technical')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.unitStatusOverview.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.unitStatusOverview.icon" :class="menu.unitStatusOverview.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.unitStatusOverview.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.unitStatusOverview.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
        -->
        <div class="row">
          <div v-if="security.canCreate('unit_cfg_templates')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.cfgTemplateCreate.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.cfgTemplateCreate.icon" :class="menu.cfgTemplateCreate.iconClass +' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.cfgTemplateCreate.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.cfgTemplateCreate.details }}</p>
              </div>
            </router-link>
          </div>
          <div class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.cfgTemplateFind.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.cfgTemplateFind.icon" :class="menu.cfgTemplateFind.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.cfgTemplateFind.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.cfgTemplateFind.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
        <div class="row">
          <h5 class="col-12 mt-3 mb-0"><fa-icon :icon="['fal', 'sms']" />&nbsp;Unit Commands</h5>
          <div class="col-12"><hr class="mb-3 mt-2"></div>
          <div v-if="security.canView('unit_commands')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.unitCommandCreate.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.unitCommandCreate.icon" :class="menu.unitCommandCreate.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.unitCommandCreate.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.unitCommandCreate.details }}</p>
              </div>
            </router-link>
          </div>
          <div class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.unitCommandFind.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.unitCommandFind.icon" :class="menu.unitCommandFind.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.unitCommandFind.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.unitCommandFind.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
        <div class="row">
          <div v-if="security.can('unit_commands', 'manage_permissions')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.unitCommandPermissions.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.unitCommandPermissions.icon" :class="menu.unitCommandPermissions.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.unitCommandPermissions.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.unitCommandPermissions.details }}</p>
              </div>
            </router-link>
          </div>
          <div v-if="security.can('unit_commands', 'view_command_logs')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.unitCommandLogs.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.unitCommandLogs.icon" :class="menu.unitCommandLogs.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.unitCommandLogs.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.unitCommandLogs.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
        <div class="row">
          <div v-if="security.can('unit_commands', 'view_command_logs')" class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.unitCommandSummary.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.unitCommandSummary.icon" :class="menu.unitCommandSummary.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.unitCommandSummary.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.unitCommandSummary.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menuItems from '@/common/menu'
import security from '@/common/security'

import {
  NAV_GET_MENU_OPEN,
  NAV_SET_MENU_OPEN
} from '@/store/navigation/nav.types'

export default {
  data () {
    return {
      menu: menuItems,
      activeMenuTab: ''
    }
  },

  mounted () {
    if (security.canView('units') || security.can('units', 'units_basic_edit')) {
      this.activeMenuTab = 'units'
    } else if (security.can('units', 'units_technical')) {
      this.activeMenuTab = 'units_technical'
    }
  },

  methods: {
    setMenuState () {
      this.$store.commit(NAV_SET_MENU_OPEN, !this.getMenuState())
    },

    getMenuState () {
      return this.$store.getters[NAV_GET_MENU_OPEN]
    },

    isMenuTabActive (tabName) {
      return tabName === this.activeMenuTab
    }
  },

  components: {
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/navigation/NavMenuTrackingUnits.vue